module.exports = __webpack_public_path__ + "static/media/ethereum-logo.a8983b94.svg";